<script>
// Read-only view of an exhibitor's public channel for the exhibitor detail
// page. Deliberately does NOT use channel.vue / channel-mixin.js: their
// mark-read call would silently create a channel membership for every viewer.
import {marked} from 'marked'
import {markedEmoji} from 'marked-emoji'
import {mdEmojiOptions} from '../lib/md-emojis'

marked.use(markedEmoji(mdEmojiOptions))

export default {
  props: {
    exhibitorSfid: {type: String, required: true},
  },

  data() {
    return {
      posts: [],
      avatars: {},
      page: 0,
      perPage: 20,
      hasMore: false,
      loaded: false,
    }
  },

  created() {
    this.fetchPosts()
  },

  methods: {
    fetchPosts(page = 0) {
      let params = {exhibitor_sfid: this.exhibitorSfid, page: page, per_page: this.perPage}
      this.$chat.get('exhibitor-channel/posts/', {params: params}).then(({data}) => {
        let newPosts = data.order.map(pid => data.posts[pid])
        this.posts = page === 0 ? newPosts : this.posts.concat(newPosts)
        this.page = page
        this.hasMore = !!data.prev_post_id
        this.loaded = true
        this.fetchAvatars(newPosts)
      }).catch(() => { this.loaded = true })
    },

    fetchAvatars(posts) {
      let userIds = [...new Set(posts.map(p => p.user_id))].filter(uid => !this.avatars[uid])
      if (!userIds.length) return
      this.$api.get('/community-users/', {params: {limit: userIds.length, uuid: userIds}})
        .then(response => {
          for (const user of response.data.results) {
            this.$set(this.avatars, user.uuid, user.profile_image)
          }
        }).catch(() => {})
    },

    authorName(post) {
      return `${post.first_name || ''} ${post.last_name || ''}`.trim() || post.username
    },

    convert2Html(markdown) {
      return marked(markdown || '')
    },

    getFormatedDate(timestamp) {
      let date = new Date(timestamp)
      return date.toLocaleDateString('de-DE', {day: 'numeric', month: 'long', year: 'numeric'})
        + ' ' + date.toLocaleTimeString('de-DE', {hour: '2-digit', minute: '2-digit'})
    },
  },
}
</script>

<template>
  <div v-if="loaded" class="mt-4">
    <hr>
    <h5 class="mb-3"><i class="bi bi-megaphone"></i> Neuigkeiten</h5>

    <div v-if="posts.length" class="list-group">
      <div v-for="post in posts" :key="post.id" class="list-group-item">
        <div class="d-flex">
          <img v-if="avatars[post.user_id]" :src="avatars[post.user_id]" class="avatar" :alt="authorName(post)" />
          <div class="flex-grow-1 ms-2 min-w-0">
            <div>
              <b>{{ authorName(post) }}</b>
              <span class="text-muted">&nbsp;{{ getFormatedDate(post.created_at) }}</span>
            </div>
            <div class="c-post" v-html="convert2Html(post.message)"></div>
          </div>
        </div>
      </div>
      <div v-if="hasMore" class="list-group-item text-center">
        <span class="btn btn-sm" @click.prevent="fetchPosts(page + 1)">
          <i class="fas fa-chevron-down"></i> Mehr laden
        </span>
      </div>
    </div>
    <div v-else class="text-muted"><small>Noch keine Beiträge.</small></div>
  </div>
</template>

<style scoped>
.avatar {
  height: 30px;
  width: 30px;
  object-fit: cover;
  border-radius: 50%;
  overflow: hidden;
}
.c-post {
  overflow-wrap: anywhere;
}
</style>
